import React from 'react';

const Spacer = () => {
    return (
        <div style={{marginBottom: "20px"}}></div>
    );
}

export default Spacer;
